// extracted by mini-css-extract-plugin
var _1 = "CardModal_activity__bsdqJ";
var _2 = "CardModal_activityItem__qQWGi";
var _3 = "CardModal_addAttachmentButton__3gsbJ";
var _4 = "CardModal_alignCenter__dS75F";
var _5 = "CardModal_buttonToggle__ryXpA";
var _6 = "CardModal_cursorPointer__t6fNr";
var _7 = "CardModal_descriptionButton__-zAfk";
var _8 = "CardModal_descriptionButtonText__EXASW";
var _9 = "CardModal_descriptionText__r57zS";
var _a = "CardModal_dropdownMenu__R9hNE";
var _b = "CardModal_flexContainer__oei-z";
var _c = "CardModal_header__+Nab2";
var _d = "CardModal_headerCount__wEHB1";
var _e = "CardModal_headerFirstLine__6f999";
var _f = "CardModal_headerItem__AV22k";
var _10 = "CardModal_headerItems__Yj6FN";
var _11 = "CardModal_headerListField__f5TBr";
var _12 = "CardModal_headerListFieldIcon__ziRgG";
var _13 = "CardModal_headerListFieldWrapper__Qgk2U";
var _14 = "CardModal_headerNotificationsButton__V41zw";
var _15 = "CardModal_headerNotificationsIcon__BpJ7l";
var _16 = "CardModal_headerTitle__uDXT2";
var _17 = "CardModal_headerTitleWrapper__SrbnX";
var _18 = "CardModal_hint__WEYmQ";
var _19 = "CardModal_hr__dgNgI";
var _1a = "CardModal_iconAddButton__ridYu";
var _1b = "CardModal_iconAddButton2__JHoDS";
var _1c = "CardModal_lastUser__fWOfZ";
var _1d = "CardModal_linkIcon__4jwip";
var _1e = "CardModal_localChangesLoaded__4o8U5";
var _1f = "CardModal_mailAuthor__TKARX";
var _20 = "CardModal_mainContainer__dQo+b";
var _21 = "CardModal_moduleContainer__D5XN2";
var _22 = "CardModal_moduleHeader__b0c7q";
var _23 = "CardModal_moduleIcon__KX6oY";
var _24 = "CardModal_moreUsers__bHCdW";
var _25 = "CardModal_popupWrapper__v8i66";
var _26 = "CardModal_taskDueDateSummaryWrapper__cQBbr";
var _27 = "CardModal_text__SCB7P";
var _28 = "CardModal_user__2b1tm";
var _29 = "CardModal_wrapper__sYgdA";
export { _1 as "activity", _2 as "activityItem", _3 as "addAttachmentButton", _4 as "alignCenter", _5 as "buttonToggle", _6 as "cursorPointer", _7 as "descriptionButton", _8 as "descriptionButtonText", _9 as "descriptionText", _a as "dropdownMenu", _b as "flexContainer", _c as "header", _d as "headerCount", _e as "headerFirstLine", _f as "headerItem", _10 as "headerItems", _11 as "headerListField", _12 as "headerListFieldIcon", _13 as "headerListFieldWrapper", _14 as "headerNotificationsButton", _15 as "headerNotificationsIcon", _16 as "headerTitle", _17 as "headerTitleWrapper", _18 as "hint", _19 as "hr", _1a as "iconAddButton", _1b as "iconAddButton2", _1c as "lastUser", _1d as "linkIcon", _1e as "localChangesLoaded", _1f as "mailAuthor", _20 as "mainContainer", _21 as "moduleContainer", _22 as "moduleHeader", _23 as "moduleIcon", _24 as "moreUsers", _25 as "popupWrapper", _26 as "taskDueDateSummaryWrapper", _27 as "text", _28 as "user", _29 as "wrapper" }
